import React from "react";
import BannerProduct from "../components/Nikea/BannerProduct";
import AboutSection from "../components/Nikea/AboutSection";
import SectionProjectDetails from "../components/Nikea/SectionProjectDetails";
import ApartmentsSection from "../components/Nikea/ApartmentsSection";
import PhotoGallery from "../components/PhotoGallery";
import ProjectWhySection from "../components/Nikea/ProjectWhySection/ProjectWhySection";
import SearchSection from "../components/Nikea/SearchSection";

const GreenHome = () => {
  return (
    <div className="relative">
      <BannerProduct />
      <AboutSection />
      <SectionProjectDetails />
      <ApartmentsSection />
      <PhotoGallery project="nikea" />
      <ProjectWhySection />
      <SearchSection project={"nikea"} />
    </div>
  );
};

export default GreenHome;
